import { render, staticRenderFns } from "./builder-single.vue?vue&type=template&id=c98f90f2&scoped=true&lang=pug"
import script from "./builder-single.vue?vue&type=script&lang=coffee"
export * from "./builder-single.vue?vue&type=script&lang=coffee"
import style0 from "./builder-single.vue?vue&type=style&index=0&id=c98f90f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c98f90f2",
  null
  
)

export default component.exports